export const TABS = [
  { type: "section", label: "Anasayfa" },

  {
    label: "Anasayfa",
    key: "dashboard",
    route: "/dashboard",
    perm: "dashboard_access",
  },
  { type: "section", label: "Admin" },
  {
    label: "Talep Ekranı",
    key: "TicketPage",
    route: "/TicketPage",
    perm: "not_view",
  },

  {
    label: "Rol Yönetimi",
    key: "role_get",
    route: "/roleManagement",
    perm: "role_get",
  },
  {
    label: "Personel Yönetimi",
    key: "personelYonetimi",
    route: "/admin/personel-yonetimi",
    perm: "personel_view",
  },
  {
    label: "Admin Ayarları",
    key: "emailSettings",
    route: "/MailSettingsPage",
    perm: "emailSettings",
  },
  { type: "section", label: "Müdür" },
  {
    label: "Navlun Firmaları",
    key: "DirectorNavlunCompany",
    route: "/DirectorNavlunCompany",
    perm: "role_get",
  },
  {
    label: "Navlun Teklif Talepleri",
    key: "DirectorNavlunRequest",
    route: "/DirectorNavlunRequest",
    perm: "role_get",
  },
  {
    label: "Navlun Analiz",
    key: "DirectorNavlunAnalysis",
    route: "/DirectorNavlunAnalysis",
    perm: "role_get",
  },
  { type: "section", label: "Genel" },
  {
    label: "Mesai Takibi",
    key: "overtimeTracking",
    route: "/mesai-takip",
    perm: "overtime_viewOwn",
  },
  {
    label: "Mesai Analizi",
    key: "overtimeAnalysis",
    route: "/mesai-analiz",
    perm: "overtime_analysis",
  },
  {
    label: "Departmanlar Arası Ortak Dokümanlar",
    key: "sharedDocsAll",
    route: "/shareddocumentall",
    perm: "document_shared_all",
  },

  { type: "section", label: "Kalite" },

  {
    label: "DOF Raporu Ekleme",
    key: "DofiWizard",
    route: "/DofiWizard",
    perm: "dof_set",
  },

  {
    // Yetki şartı yok: herkes kendi açtığı / kendisine atanan DÖF'leri ve bekleyen işlerini görür.
    // Tüm DÖF'leri görmek için dof_viewAll gerekir (backend'de kontrol ediliyor).
    label: "DÖF Listesi / İşlerim",
    key: "dof_get",
    route: "/DofList",
  },

  {
    label: "Yaratıcı Öneriler",
    key: "kaizen_view",
    route: "/KaizenOnerileri",
    perm: "kaizen_view",
  },

  {
    label: "Sevk Raporu Analizi",
    key: "qualitySevkDoc",
    route: "/sevkRapor",
    perm: "sevk_rapor",
  },
  {
    label: "Kalite Ortak Doküman Havuzu",
    key: "qualitySharedDocs",
    route: "/ortakKalite",
    perm: "kalite_shared_viewOwn",
  },
  {
    label: "Bilgi Dokümanları",
    key: "qualityDocs",
    route: "/quality",
    perm: "kalite_viewOwn",
  },

  {
    label: "Standart Belgeleri",
    key: "standardDocs",
    route: "/standardDocument",
    perm: "standart_viewOwn",
  },
  { type: "section", label: "Satış" },

  {
    label: "Müşteri Stok Gönderme",
    key: "CustomerStokMail",
    route: "/RuloStokSatisGiris",
    perm: "CustomerStokMail",
  },
  {
    label: "Satış Dosyaları",
    key: "satisDocs",
    route: "/salesDocuments",
    perm: "satis_viewOwn",
  },
  { type: "section", label: "Muhasebe" },

  {
    label: "Yurt İçi Alım XML",
    key: "DomesticPurchaseXml",
    route: "/DomesticPurchaseXml",
    perm: "muhasebe_shared_viewOwn",
  },

  {
    label: "İhracaat Fatura Karşılaştırma",
    key: "InvoiceComparison",
    route: "/InvoiceComparison",
    perm: "muhasebe_shared_viewOwn",
  },
  {
    label: "Diib Eşleştirme",
    key: "DiibTemporaryClosurePage",
    route: "/DiibTemporaryClosurePage",
    perm: "muhasebe_shared_viewOwn",
  },
  {
    label: "DİİB Fatura Mutabakatı",
    key: "DiibReconciliation",
    route: "/DiibReconciliation",
    perm: "muhasebe_shared_viewOwn",
  },

  {
    label: "Muhasebe Ortak Doküman Havuzu",
    key: "muhasebeSharedDocs",
    route: "/ortakMuhasebe",
    perm: "muhasebe_shared_viewOwn",
  },

  {
    label: "Muhasebe Dosyaları",
    key: "finansDocs",
    route: "/accountingDocument",
    perm: "muhasebe_viewOwn",
  },

  { type: "section", label: "ISG" },

  {
    label: "Personel Eğitim Takip",
    key: "IsgPersonelList",
    route: "/IsgPersonelCertifica",
    perm: "isg_personel_get",
  },
  {
    label: "ISG Ortak Doküman Havuzu",
    key: "isgSharedDocs",
    route: "/ortakIsg",
    perm: "isg_shared_viewOwn",
  },
  {
    label: "Fabrika Hatırlatıcı Modülü",
    key: "IsgDocument",
    route: "/IsgDocument",
    perm: "isg_viewOwn",
  },
  { type: "section", label: "Sevkiyat" },

  {
    label: "Kantar Fotoğraf Oluşturma",
    key: "sevkiyat_get_list_planlama",
    route: "/sevkiyat/kantar-fotograf",
    perm: "sevkiyat_kantar_foto_generate",
  },
  {
    label: "Sevkiyat Form",
    key: " /sevkiyat/yukleme-kontrol",
    route: "/sevkiyat/yukleme-kontrol",
    perm: "sevkiyat_kantar_form",
  },

  //Sevkiyat
  {
    label: "Sevkiyat-Planlama Liste",
    key: "sevkiyat_get_list_planlama",
    route: "/SevkiyatPlanlamaListe",
    perm: "sevkiyat_get_list_planlama",
  },
  {
    label: "Sevkiyat Liste",
    key: "sevkiyatListe",
    route: "/sevkiyatListe",
    perm: "sevkiyat_get_list",
  },

  { type: "section", label: "Üretim" },

  {
    label: "Kalip Kullanim Analiz",
    key: "ScadaDashboard",
    route: "/AylikKalipKullanimAnalizi",
    perm: "scadaView",
  },
  {
    label: "Kalıp Hız Analizi",
    key: "ScadaDashboard",
    route: "/KalipAnalizPage",
    perm: "scadaView",
  },
  {
    label: "Operatör Duruş KPI",
    key: "OperatorDurusKpiPage",
    route: "/OperatorDurusKpiPage",
    perm: "scadaView",
  },
  {
    label: "Makina Hızları",
    key: "ScadaDashboard",
    route: "/ScadaDashboard",
    perm: "scadaView",
  },
  {
    label: "Üretim Veri Tablosu",
    key: "MakinaUretimAnalizDemo",
    route: "/MakinaUretimAnalizDemo",
    perm: "uretim_makina_analiz",
  },
  {
    label: "Ort. Kalınlık Analizi",
    key: "MakinaOrtalamaKalinlikAnaliz",
    route: "/MakinaOrtalamaKalinlikAnaliz",
    perm: "uretim_makina_analiz",
  },
  {
    label: "Excel Debug",
    key: "MakinaExcelDebugPage",
    route: "/MakinaExcelDebugPage",
    perm: "uretim_makina_analiz",
  },
  {
    label: "Excel İçe Aktarım Kontrol",
    key: "MakinaExcelImportKontrolPage",
    route: "/MakinaExcelImportKontrolPage",
    perm: "uretim_makina_analiz",
  },
  {
    label: "Boru Profil Günlük Özet",
    key: "boruProfilGunlukOzet",
    route: "/BoruProfilAnlik",
    perm: "uretim_boruProfilAnlik",
  },
  // {
  // geliştirme
  //   label: "Üretim Makina Hız Farkları",
  //   key: "HizPerformansRaporuPage",
  //   route: "/HizPerformansRaporuPage",
  //   perm: "hizKontrolAnaliz_get",
  // },
  {
    label: "Üretim Süre Analiz",
    key: "uretimSureAnaliz",
    route: "/MakineSureAnaliz",
    perm: "uretim_makine_sure_analiz",
  },
  {
    label: "Aylık Boru Profil Analiz",
    key: "aylikBoruProfilAnaliz",
    route: "/aylikBoruProfilAnaliz",
    perm: "uretim_aylikBoruProfilAnaliz",
  },
  {
    label: "Yeni B.P Günlük Özet Analiz",
    key: "boruProfilGunlukUretimAnaliz",
    route: "/BoruProfilUretimGunlukAnaliz",
    perm: "uretim_boruProfilUretimGunlukAnaliz",
  },
  {
    label: "Günlük Tonaj Takip",
    key: "boruToplamSureAnaliz",
    route: "/ToplamGunlukSureAnaliz",
    perm: "uretim_boruProfilUretimGunlukAnaliz",
  },
  {
    label: "Süre Analizi",
    key: "BoruSureAnaliz",
    route: "/BoruSureAnaliz",
    perm: "uretim_boruProfilUretimGunlukAnaliz",
  },

  {
    label: "Üretim Ortak Doküman Havuzu",
    key: "uretimSharedDocs",
    route: "/ortakUretim",
    perm: "uretim_shared_viewOwn",
  },
  {
    label: "Üretim Dosyaları",
    key: "uretimDocs",
    route: "/uretimDocument",
    perm: "uretim_viewOwn",
  },
  { type: "section", label: "İdari İşler" },

  {
    label: "Bakımlar",
    key: "idariBakim_get",
    route: "/HygienePlanPage",
    perm: "idariBakim_get",
  },
  {
    label: "Yemekhane Yıllık Temizlik",
    key: "diningHallCleaningPlan_list",
    route: "/DiningHallCleaningPlanManagement",
    perm: "diningHallCleaningPlan_list",
  },
  {
    label: "İdari İşler Dosyaları",
    key: "idariDocs",
    route: "/administrativeDocument",
    perm: "IdariIsler_viewOwn",
  },

  { type: "section", label: "İnsan Kaynakları" },
  {
    label: "İK Ortak Doküman Havuzu",
    key: "ikSharedDocs",
    route: "/ortakInsanKaynaklari",
    perm: "insanKaynaklari_shared_viewOwn",
  },
  {
    label: "İK Dosyaları",
    key: "ikDocs",
    route: "/hrDocument",
    perm: "InsanKaynaklari_viewOwn",
  },

  { type: "section", label: "Planlama" },

  {
    label: "Üretim Planlama",
    key: "uretimPlanlama_get",
    route: "/UretimPlanlamaPage",
    perm: "hat_hiz_standart_get",
  },
  {
    label: "Sevkiyat Canlı Kameralar",
    key: "sevkiyatLiveCameras",
    route: "/planning/sevkiyat-kameralari",
    perm: "sevkiyat_live_camera_view",
  },
  {
    label: "Üretim-Satış Raporu",
    key: "productionSalesSummary",
    route: "/planning/uretim-satis-raporu",
    perm: "planlama_uretim_satis_raporu",
  },
  {
    label: "Kapasite Hesap Verileri",
    key: "hat_hiz_standart_get",
    route: "/hathizstandart",
    perm: "hat_hiz_standart_get",
  },
  {
    label: "Stok Analiz",
    key: "stokAnaliz",
    route: "/stokAnaliz",
    perm: "planlama_stokAnaliz",
  },
  {
    label: "Planlama Dosyaları",
    key: "planlamaDocs",
    route: "/planningDocument",
    perm: "planlama_viewOwn",
  },
  {
    label: "Konteyner Yükleme Planı",
    key: "konteynerYukleme",
    route: "/planning/konteyner-yukleme",
    perm: "konteynerPlan_view",
  },
  {
    label: "Konteyner Kuralları ve Müşteriler",
    key: "konteynerKurallar",
    route: "/planning/konteyner-kurallar",
    perm: "konteynerPlan_view",
  },

  { type: "section", label: "Dış Ticaret" },
  {
    label: "Navlun Teklifleri",
    key: "NavlunFreightPricePage",
    route: "/NavlunFreightPricePage",
    perm: "navlunFreightPrice_viewAll",
  },

  {
    label: "Sipariş Listesi",
    key: "ExportOrder",
    route: "/ExportOrder",
    perm: "customer_analysis",
  },
  {
    label: "Müşteri Analiz",
    key: "CustomerAnalysisPage",
    route: "/CustomerAnalysisPage",
    perm: "customer_analysis",
  },
  {
    label: "Payment List",
    key: "PaymentDueListe",
    route: "/PaymentDueListDemo",
    perm: "vessel_get",
  },

  {
    label: "Müşteri Bilgi Arşivi",
    key: "CustomerListPage",
    route: "/CustomerList",
    perm: "customer_get",
  },
  {
    label: "EU Kota",
    key: "steelOnePlanB",
    route: "/eukota",
    perm: "disTicaret_steelone",
  },
  {
    label: "UK Kota",
    key: "steelOnePlanC",
    route: "/ukkota",
    perm: "disTicaret_steelone",
  },
  {
    label: "Dış Ticaret Ortak Doküman Havuzu",
    key: "disTicaretSharedDocs",
    route: "/ortakDisTicaret",
    perm: "disTicaret_shared_viewOwn",
  },
  {
    label: "Dış Ticaret Dosyaları",
    key: "disTicaretDocs",
    route: "/foreignTradeDocument",
    perm: "disTicaret_viewOwn",
  },

  { type: "section", label: "Satınalma ve Depo" },
    {
    label: "Yemek Listesi",
    key: "MonthlyMealMenuPage",
    route: "/MonthlyMealMenuPage",
    perm: "monthlyMealMenu_view",
  },
  {
    label: "Satın Alma Ortak Doküman Havuzu",
    key: "satinAlmaShared",
    route: "/ortakSatinAlma",
    perm: "satinalma_shared_viewOwn",
  },

  {
    label: "Satınalma Dökümanları",
    key: "satinalmaDocs",
    route: "/satinAlmaDocument",
    perm: "satinalma_viewOwn",
  },

  { type: "section", label: "Bakım" },

  {
    label: "Kritik Ekipman Yıllık Kontrol Çizelgesi",
    key: "equipment_plan_list",
    route: "/equipmentPlanManagement",
    perm: "equipment_plan_list",
  },
  {
    label: "Makina Bakım Planı",
    key: "cleaningPlan_list",
    route: "/CleaningPlanManagement",
    perm: "cleaningPlan_list",
  },
  {
    label: "Bakım Dökümanları",
    key: "bakimDocs",
    route: "/bakimdocument",
    perm: "bakim_viewOwn",
  },
];
